import { render, staticRenderFns } from "./myDiscount.vue?vue&type=template&id=3127bd91&scoped=true&"
import script from "./myDiscount.vue?vue&type=script&lang=js&"
export * from "./myDiscount.vue?vue&type=script&lang=js&"
import style0 from "./myDiscount.vue?vue&type=style&index=0&id=3127bd91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127bd91",
  null
  
)

export default component.exports